export const MEDIA_PARENT_ENTITY = {
  ORGANIZATION: 'Organization',
  EVENT: 'Event',
  SESSION: 'Session',
  FLOW: 'Flow',
} as const;

export type MediaParentEntity = (typeof MEDIA_PARENT_ENTITY)[keyof typeof MEDIA_PARENT_ENTITY];
